import React, {
  useContext,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
  useCallback,
  useState,
} from "react";
import ReactHowler from "react-howler";

// import canAutoplay from "can-autoplay";
// import { AUDIO } from "can-autoplay/lib/media";
import { playerStoreContext } from "lib/player_store";
import { observer } from "mobx-react-lite";
import { usd } from "lib/player_util.js";
import I18n from "i18n/index.js.erb";

const AudioPlayer = (props, ref) => {
  useImperativeHandle(ref, () => {
    return {
      getSeek: getSeek,
      stop: stop,
      skip: skip,
      //  handleOnPlay: handleOnPlay,
    };
  });

  const store = useContext(playerStoreContext);
  const playerRef = useRef();
  const lastTime = useRef(0);
  const [skipping, setSkipping] = useState(false);
  // const initialRender = useRef(true);

  const [playable, setPlayable] = useState(false);

  const {
    paused,
    volume,
    songInfo: { url, artist, song, album_art, monetized },
  } = store;

  // useEffect(() => {
  //   if ("mediaSession" in navigator) {
  //     const mediaSession = navigator.mediaSession;
  //     mediaSession.playbackState = "none";
  //   }
  // }, []);

  useEffect(() => {
    if (url) {
      store.set_songTime(0);
      store.setDuration(0);
      setPaused(false);
      setSkipping(false);
      lastTime.current = 0;
    }
  }, [url]);

  useEffect(() => {
    // window.Howler.autoUnlock = false;
    window.Howler.autoSuspend = false;
    //  console.log("USE EFFECT PLAYABLE", playable)
    if (playable && "mediaSession" in navigator) {
      const mediaSession = navigator.mediaSession;

      mediaSession.setActionHandler("play", () => {
        store.setPaused(false);
      });

      mediaSession.setActionHandler("pause", () => {
        store.setPaused(true);
      });

      mediaSession.setActionHandler("nexttrack", () => {
        skipIf();
      });

      // mediaSession.setActionHandler("seekto", null);
      // mediaSession.setActionHandler("seekbackward", null);
      // mediaSession.setActionHandler("seekforward", null);
      // mediaSession.setActionHandler("previoustrack", null);
    }
  }, [playable]);

  useEffect(() => {
    if (playable && "mediaSession" in navigator) {
      const mediaSession = navigator.mediaSession;
      mediaSession.playbackState = paused ? "paused" : "playing";
    }
  }, [playable, paused]);

  useEffect(() => {
    if (playable && url) {
      updateMediaSessionMetaData();
    }
  }, [playable, url]);

  const skipIf = () => {
    if (monetized) {
      return false;
    } else {
      props.skip();
    }
  };

  const setPaused = useCallback((v) => {
    store.setPaused(v);
  });

  const updateMediaSessionMetaData = () => {
    if ("mediaSession" in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: song,
        artist: artist,
        //album: "The Ultimate Collection (Remastered)",
        artwork: [{ src: album_art, sizes: "340x340", type: "image/jpg" }],
      });
    }
  };

  // const testAutoplay = useCallback(() => {
  //   canAutoplay
  //     .audio({ timeout: 3000, muted: false })
  //     .then(({ result, error }) => {
  //       console.log("autoplayable:", result);

  //       if (result === true) {
  //         setPaused(false);
  //         store.set_autoplayable(true);
  //       } else {
  //         console.log("autoplay error:", error);
  //         handleRejection();
  //       }
  //     });
  // });

  // useEffect(() => {
  //   console.log("audioplayer songTime", songTime);
  // }, [songTime]);

  // useEffect(() => {
  //   testAutoplay();

  //   return () => {
  //     clearRAF();
  //   };
  // }, []);

  // useEffect(() => {
  //   if (!paused && !store.freakingOut) {
  //     if ([0, NaN].includes(store.duration)) {
  //       setDuration();
  //     }
  //   }
  // }, [url]);

  useEffect(() => {
    clearRAF();
    console.log("useeffect PAUSED", paused);
    if (!paused) {
      clearRAF();
      startAnim();
    }
    return () => {
      clearRAF();
    };
  }, [paused, url, clearRAF]);

  // useEffect(() => {
  //   console.log("playerStopTrigger", playerStopTrigger);
  //   if (playerStopTrigger > 0) {
  //     stop();
  //   }
  // }, [playerStopTrigger]);

  const getDuration = () => {
    return playerRef.current?.duration();
  };

  const setDuration = () => {
    const d = getDuration();
    //    console.log("getDuration", d);
    store.setDuration(d);
  };

  const _seekTo = (ts) => {
    //  console.log("ts", ts, "storeTime", store.songTime, player);
    playerRef.current?.seek(ts);
  };

  const _playing = () => {
    return playerRef?.current?.howler.playing();
  };

  const _getHowler = () => {
    return playerRef.current.howler;
  };

  const getSeek = () => {
    //console.log("seek", playerRef.current?.seek());
    return playerRef.current?.seek();
  };

  const handleOnLoad = () => {
    // console.log("SOUND LOADED");
    setDuration();
  };

  const set_autoplayOverlay = (v) => {
    store.set_autoplayOverlay(v);
  };

  const handleRejection = () => {
    console.log("handleRejection");
    //store.set_autoplayable(false);

    setPaused(true);
    stop();

    // playerRef.current.howler.once("unlock", () => {
    //   console.log("UNLOCK!");
    //   this.play();
    // });
    // console.log("YO", playerRef.current.howler)

    set_autoplayOverlay("trigger");
  };

  // only for pre-17.5 iOS ?
  //const handleUnlock = () => {
  // console.info("UNLOCK! *******");
  // if (!playerRef.current.howler.playing()) {
  //   // calling this more than once plays multiple instances at once!
  //   playerRef.current.howler.play();
  // }
  //};

  const handleLoadError = () => {
    console.log("AudioPlayer LOAD ERROR");

    showFreaking();
  };

  const showFreaking = () => {
    //   console.log("Player: I'm freaking out");
    store.set_loading(false);
    store.merge({
      song: I18n.t("client_application_copy.this_is").replace(
        "&hellip;",
        String.fromCharCode(8230),
      ),
      artist: "",
      album: "",
      video_id: null,
    });
    setSongTime(0);
    setPaused(true);
    setSkipping(false);
    store.set_autoplayOverlay("closed");
    store.setFreakingOut(true);
  };

  const setSongTime = (newTime) => {
    store.set_songTime(newTime);
  };

  const handlePlayError = (soundId, errorCode) => {
    console.log(
      "AudioPlayer PLAY ERROR - ",
      "soundId:",
      soundId,
      "errorCode:",
      errorCode,
      "paused:",
      paused,
    );
    handleRejection();
  };

  const handleOnPlay = () => {
    console.log("handleOnPlay");
    setPaused(false);
    setPlayable(true);
    setDuration();
  };

  const skip = () => {
    setSkipping(true);
  };

  const stop = () => {
    console.log("audioPlayer STOP");
    playerRef.current?.stop();
  };

  const handleStop = () => {
    console.log("HANDLESTOP");
    // lastTime.current = 0;
    // setPaused(true);

    // //store.set_songTime(0);
    // clearRAF();
  };

  // const handleOnPause = () => {
  //   setPaused(true);
  // };

  const handleOnEnd = () => {
    if (!url) {
      setPaused(true);
      // stop();
      return;
    }
    clearRAF();
    _jm.skipped = false;
    _jm.next = true;
    usd();
  };

  let _raf;

  const startAnim = () => {
    _raf = window.requestAnimationFrame(renderSeekPos);
  };

  const renderSeekPos = () => {
    const currentTime = getSeek();
    //console.log("lastTime", lastTime.current, "currentTime", currentTime);
    if (typeof currentTime == "number") {
      let delta = currentTime - lastTime.current;

      if (delta >= 0.5) {
        lastTime.current = currentTime;
        store.set_songTime(currentTime);
      }
    }

    if (!paused) {
      startAnim();
    } else {
      clearRAF();
    }
  };

  const clearRAF = useCallback(() => {
    window.cancelAnimationFrame(_raf);
  });

  // silent file from can-autoplay
  // test autoplay immediately
  // show overlay with callback to play if not allowed
  const AUDIO =
    "data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq";

  return (
    <ReactHowler
      src={url || AUDIO}
      preload={Boolean(url)}
      /* destructed "paused" not updating reliably */
      playing={!paused && !skipping}
      onLoad={handleOnLoad}
      onLoadError={handleLoadError}
      onPlayError={handlePlayError}
      // onUnlock={handleUnlock}
      onPlay={handleOnPlay}
      //  onPause={handleOnPause}
      onStop={handleStop}
      onEnd={handleOnEnd}
      loop={false}
      mute={false}
      volume={volume}
      /* html5=true allows "streaming" i.e. dont need entire file to decode and start play
        -- potentionally requiring partial replacement turbolinks lib
        -- also sidesteps webaudio api ajax issue with Access-Control-Allow-Origin missing with cloudfront (now fixed)
        */
      html5={true} /* detect edge hard media block and chromeos ? */
      ref={playerRef}
    />
  );
};

export default observer(forwardRef(AudioPlayer));
